'use client';

import { IconChevronDown } from '@actr/icons/chevron-down';
import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import React, { memo, useState } from 'react';

import * as Styled from './style.css';

export type AllPointsProps = {
  title: string;
  cities: {
    name: string;
    path: string;
  }[] | null;}

const AirlineCities: React.FC<AllPointsProps> = ({ title, cities }) => {
  const [hideShowMoreButton, setHideShowMoreButtonCount] = useState(false);

  function handleShowMoreButton() {
    setHideShowMoreButtonCount(true);
  }

  if (!cities) {
    return null;
  }

  return (
    <ContentBlock id="cities_for_airline">
      <Text tagName="h3" font="title.x2l">{title}</Text>
      <div className={Styled.MainWrapper}>
        {cities.map((city, index) => {
          const isHidden = !hideShowMoreButton && index > 24;
          const isMobileHidden = !hideShowMoreButton && index > 14;

          return (
            <a
              className={Styled.Flight({
                isHidden,
                isMobileHidden
              })}
              key={index}
              href={city.path ? `/${city.path}` : undefined}>
              {city.name}
            </a>
          );
        })}
      </div>
      {!hideShowMoreButton && (
      <Button
        className={Styled.ShowMoreButton({
          flights: cities?.length < 22
        })}
        onClick={handleShowMoreButton}
        rightIcons={<IconChevronDown />}
        buttonType={ButtonTypes.TERTIARY}
        size={ButtonSizes.S}>
        Ещё города
      </Button>
      )}
    </ContentBlock>
  );
};

export default memo(AirlineCities);
